/* MyTomette — hero alterné de l'accueil (Lot M, 15/10/2026).
 * 4 héros (snippets mt-hero-<id> → article.mt-hero-slide), barre d'onglets façon brindille.co/beta2,
 * palette par data-ton (mt-home-reel.css). Contrat avec les héros, sur l'article :
 *   'mt-hero:entree' {detail:{reduit}} · 'mt-hero:sortie' · 'mt-hero:pause' · 'mt-hero:reprise'
 *   (+ 'mt-hero:precharge' et son alias 'mt-hero:prechargement' ~2,5 s avant l'entrée prévue, ou au survol/focus de l'onglet : facultatif).
 * État lisible à tout moment (pour un script qui arrive après l'événement) :
 *   article[data-hero-actif] · article[data-hero-gele] · article[data-hero-reduit].
 * Règles (cf. étude Brindille, bugs à ne pas reproduire) :
 *   - la jauge EST la minuterie (animation CSS, fin = héros suivant) ; un survol/focus la met en
 *     pause (sans la remettre à zéro), « Reprendre » relance vraiment ;
 *   - clic/flèche/balayage sur un héros = arrêt explicite et visible (le bouton dit « Reprendre ») ;
 *     si l'utilisateur avait mis en pause, le héros choisi reste figé (WCAG 2.2.2) ;
 *   - le focus clavier fige le temps de la visite, et seulement lui (focusout le relâche) ;
 *   - mouvement réduit : pas de rotation, pas de jauge, bouton masqué, onglets actifs, bascule sèche.
 * Compatibilité : 'mt:hero-slide-change' {index,id} sur la racine (mt-hero-gravures coupe son laser hors « mots »).
 * Téléphone, disposition B Socle (16/10/2026) : la mise en page est en CSS pur (mt-home-reel.css) ; ce script n'y ajoute que
 * html[data-hero-socle], qui replie « −10 % » et WhatsApp tant que le socle est en bas de l'écran.
 */
(()=>{'use strict';
 const instances=new WeakMap();
 const emit=(el,type,detail)=>el.dispatchEvent(new CustomEvent(type,{bubbles:true,detail}));
 function init(root){
  if(instances.has(root))return;
  const pile=root.querySelector('[data-hero-pile]');
  const slides=pile?[...pile.children].filter(e=>e.classList.contains('mt-hero-slide')):[];
  const tabs=[...root.querySelectorAll('[role=tab][data-hero-cible]')];
  const pause=root.querySelector('[data-hero-pause]');
  const bar=root.querySelector('[data-hero-barre]');
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const placer=()=>{try{window.mtHeroPlacer&&window.mtHeroPlacer(root);}catch(e){}};
  slides.forEach(s=>{s.hidden=false;s.querySelectorAll('[data-home-slide][hidden]').forEach(x=>x.hidden=false);});
  if(slides.length<2||!tabs.length||!pause){root.dataset.heroPret='true';slides[0]&&slides[0].setAttribute('data-hero-actif','');placer();return;}
  // onglet ↔ héros (par data-hero-id) ; liens ARIA
  const tabOf=slides.map(s=>tabs.find(t=>t.dataset.heroCible===s.dataset.heroId)||null);
  const roleDesc=root.dataset.heroRoledesc;
  slides.forEach((s,i)=>{
   if(!s.id)s.id=root.id+'-'+(s.dataset.heroId||i);
   s.setAttribute('role','tabpanel');
   // « slide » du contrat, traduit par la section (diapositive en français)
   if(roleDesc)s.setAttribute('aria-roledescription',roleDesc);
   const t=tabOf[i];if(t){t.setAttribute('aria-controls',s.id);s.setAttribute('aria-labelledby',t.id);}
  });
  let index=0,arret=false,gel=false,survol=false,focusClavier=false,visible=true,disposed=false,animGelee=false,timerPre=0,swipeX=null,swipeY=null,bloqueClic=0;
  const abort=new AbortController(),on=(n,t,f,o)=>n.addEventListener(t,f,Object.assign({signal:abort.signal},o||{}));
  const reduit=()=>motion.matches;
  const duree=i=>{const d=parseInt(slides[i].dataset.heroDuree,10);return d>=2000&&d<=60000?d:9000;};
  const tourne=()=>!disposed&&!arret&&!reduit()&&visible&&!survol&&!focusClavier&&!document.hidden;
  const hydrate=s=>s.querySelectorAll('template[data-home-deferred]').forEach(t=>t.replaceWith(t.content.cloneNode(true)));
  const precharge=i=>{const s=slides[i];if(!s||s.dataset.heroPrecharge)return;s.dataset.heroPrecharge='true';hydrate(s);emit(s,'mt-hero:precharge',{});emit(s,'mt-hero:prechargement',{});};
  function etat(){
   root.dataset.heroTourne=String(tourne());
   root.toggleAttribute('data-hero-arret',arret);
   root.toggleAttribute('data-hero-reduit',reduit());
   pause.hidden=reduit();
   // libellé visible : les deux mots sont déjà dans le bouton (largeur fixe = plus long des deux), le CSS montre le bon
   pause.setAttribute('aria-label',arret?pause.dataset.ariaReprendre:pause.dataset.ariaPause);
   pile.setAttribute('aria-live',arret||reduit()?'polite':'off');
   // animations du héros actif : gelées sur « Mettre en pause », hors écran ou onglet caché
   const g=!reduit()&&(gel||!visible||document.hidden);
   if(g!==animGelee){animGelee=g;const s=slides[index];s.toggleAttribute('data-hero-gele',g);emit(s,g?'mt-hero:pause':'mt-hero:reprise',{});}
  }
  function jauge(i,repart){
   tabs.forEach(t=>{const j=t.querySelector('.mt-hero-onglet__jauge');if(j&&(repart||t!==tabOf[i])){j.style.animation='none';}});
   const t=tabOf[i],j=t&&t.querySelector('.mt-hero-onglet__jauge');
   if(j){j.style.setProperty('--hero-duree',duree(i)+'ms');void j.offsetWidth;j.style.animation='';}
  }
  function planPre(){
   clearTimeout(timerPre);
   if(reduit()||arret)return;
   const n=(index+1)%slides.length;
   timerPre=setTimeout(()=>precharge(n),Math.max(0,duree(index)-2500));
  }
  function show(next,o){
   o=o||{};
   next=(next+slides.length)%slides.length;
   if(disposed||(next===index&&!o.force))return;
   const prev=slides[index],cur=slides[next],sec=o.sec||reduit();
   if(sec)root.classList.add('mt-home-reel--sec');
   if(next!==index){
    prev.removeAttribute('data-hero-actif');prev.inert=true;prev.setAttribute('aria-hidden','true');prev.removeAttribute('data-hero-gele');
    emit(prev,'mt-hero:sortie',{});
   }
   index=next;hydrate(cur);cur.dataset.heroPrecharge='true';
   cur.setAttribute('data-hero-actif','');cur.inert=false;cur.removeAttribute('aria-hidden');
   cur.toggleAttribute('data-hero-reduit',reduit());
   root.dataset.ton=cur.dataset.ton||'lin';root.dataset.heroI=String(index);root.dataset.active=String(index);
   tabs.forEach(t=>{const a=t===tabOf[index];t.setAttribute('aria-selected',String(a));t.tabIndex=a?0:-1;});
   animGelee=false;
   emit(cur,'mt-hero:entree',{reduit:reduit()});
   root.dispatchEvent(new CustomEvent('mt:hero-slide-change',{detail:{index,id:cur.dataset.heroId}}));
   jauge(index,true);planPre();etat();
   if(sec){void root.offsetWidth;requestAnimationFrame(()=>requestAnimationFrame(()=>root.classList.remove('mt-home-reel--sec')));}
  }
  // choix manuel : la rotation s'arrête ; une pause demandée (gel) est conservée et le héros entrant la reçoit
  function manuel(i,o){arret=true;show(i,o);etat();}
  // la jauge est la minuterie
  tabs.forEach((t,k)=>{
   const j=t.querySelector('.mt-hero-onglet__jauge');
   if(j)on(j,'animationend',()=>{if(t===tabOf[index]&&tourne())show(index+1);});
   const i=tabOf.indexOf(t);
   on(t,'click',()=>{if(i<0)return;if(i===index&&arret)return;manuel(i);});
   on(t,'pointerenter',()=>i>=0&&precharge(i));
   on(t,'focus',()=>i>=0&&precharge(i));
  });
  // clavier : flèches, Début, Fin (activation automatique, motif « tabs » de l'APG)
  on(root.querySelector('[role=tablist]'),'keydown',e=>{
   const k=tabs.indexOf(document.activeElement);if(k<0)return;
   let n=null;
   if(e.key==='ArrowRight'||e.key==='ArrowDown')n=(k+1)%tabs.length;
   else if(e.key==='ArrowLeft'||e.key==='ArrowUp')n=(k-1+tabs.length)%tabs.length;
   else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;
   if(n===null)return;
   e.preventDefault();tabs[n].focus();const i=tabOf.indexOf(tabs[n]);if(i>=0)manuel(i);
  });
  on(pause,'click',()=>{
   if(arret){arret=false;gel=false;jauge(index,true);planPre();}
   else{arret=true;gel=true;clearTimeout(timerPre);}
   etat();
  });
  // survol (souris seulement) de la barre ou de la scène : la jauge s'arrête, sans repartir de zéro
  const zonesSurvol=[bar].concat(slides.map(s=>s.querySelector('[data-hero-scene],.mt-hero-scene,.musee-hero-stage-wrap,.mt-photo-hero__scene,[class*="__scene"]'))).filter(Boolean);
  zonesSurvol.forEach(z=>{
   on(z,'pointerenter',e=>{if(e.pointerType==='mouse'){survol=true;etat();}});
   on(z,'pointerleave',e=>{if(e.pointerType==='mouse'){survol=zonesSurvol.some(x=>x!==z&&x.matches(':hover'));etat();}});
  });
  // focus clavier dans le héros (hors bouton pause) : on fige le temps de la visite
  const focusFige=()=>{const a=document.activeElement;return !!a&&root.contains(a)&&!pause.contains(a)&&a.matches(':focus-visible');};
  on(root,'focusin',()=>{focusClavier=focusFige();etat();});
  on(root,'focusout',()=>requestAnimationFrame(()=>{if(disposed)return;focusClavier=focusFige();etat();}));
  // balayage au doigt sur les héros (pas sur la barre) ; le défilement vertical reste natif (touch-action:pan-y)
  on(pile,'pointerdown',e=>{if(e.pointerType==='mouse')return;swipeX=e.clientX;swipeY=e.clientY;},{passive:true});
  const finSwipe=e=>{
   if(swipeX===null)return;const dx=e.clientX-swipeX,dy=e.clientY-swipeY;swipeX=null;
   if(e.type==='pointerup'&&Math.abs(dx)>40&&Math.abs(dx)>1.5*Math.abs(dy)){bloqueClic=Date.now();manuel(index+(dx<0?1:-1));}
  };
  on(pile,'pointerup',finSwipe);on(pile,'pointercancel',finSwipe);
  on(pile,'click',e=>{if(Date.now()-bloqueClic<450){e.preventDefault();e.stopPropagation();}},{capture:true});
  on(document,'visibilitychange',etat);
  on(motion,'change',()=>{if(reduit()){clearTimeout(timerPre);}else{jauge(index,true);planPre();}slides[index].toggleAttribute('data-hero-reduit',reduit());etat();});
  const io=typeof IntersectionObserver==='function'?new IntersectionObserver(([en])=>{visible=en.isIntersecting;etat();},{threshold:.15}):null;
  if(io)io.observe(root);
  // placement au téléphone (--hero-sc-bas, bas de la scène lu par le voile du lieu ; depuis la disposition B, la hauteur des
  // scènes est en CSS pur) : recalculé si une scène, un texte ou la largeur change
  let rafPl=0;const replacer=()=>{cancelAnimationFrame(rafPl);rafPl=requestAnimationFrame(placer);};
  const ro=typeof ResizeObserver==='function'?new ResizeObserver(replacer):null;
  if(ro){ro.observe(root);slides.forEach(s=>{const sc=s.__mthSc;if(sc)ro.observe(sc);const tx=s.querySelector('.musee-hero-copy');if(tx)ro.observe(tx);});}
  on(window,'resize',replacer);
  // réserve à droite de la barre (bureau) : 200 px par défaut (pastille −10 % + WhatsApp) ; recalculée après un clic
  // (fermeture de la pastille : décalage couvert par l'interaction, donc sans CLS) et au redimensionnement
  const barIn=bar&&bar.querySelector('.mt-hero-barre__in');let reserveFaite=false;
  const reserve=()=>{
   if(disposed||!barIn)return;
   if(!matchMedia('(min-width:880px)').matches){root.style.removeProperty('--hero-reserve');return;}
   const W=document.documentElement.clientWidth;let g=W;
   document.querySelectorAll('.mtnl-bubble,#mtnl-bubble,.mtwa-launcher,#mtwa-launcher').forEach(e=>{const c=getComputedStyle(e);if(c.display==='none'||c.visibility==='hidden'||+c.opacity===0)return;const b=e.getBoundingClientRect();if(b.width&&b.left>W*.5&&b.bottom>innerHeight-140)g=Math.min(g,b.left);});
   const pl=parseFloat(getComputedStyle(barIn).paddingLeft)||0;
   root.style.setProperty('--hero-reserve',Math.round(Math.max(pl,W-g+12))+'px');reserveFaite=true;
  };
  on(document,'click',()=>{setTimeout(reserve,150);},{capture:true,passive:true});
  on(window,'resize',()=>{if(reserveFaite)reserve();});
  // Disposition B Socle (16/10/2026), téléphone : les pastilles « −10 % » et WhatsApp se replient tant que le socle
  // occupe leur zone, en bas de l'écran (html[data-hero-socle], lu par mt-home-reel.css) ; elles reviennent dès qu'il
  // est remonté au-dessus (≈ 60 px de défilement). On mesure le socle lui-même : juste aussi en paysage, où il est sous le pli.
  const tel=matchMedia('(max-width:879px)');let rafSocle=0;
  // Barre appli C3 (16/10/2026) : en mode barre (html.mt-barre, ≤ 860 px), la barre du bas occupe --mt-barre-tot et WhatsApp
  // est posé juste au-dessus d'elle : sa zone remonte d'autant. Hauteur lue une fois dans --mt-barre-tot (sonde invisible,
  // seule façon d'obtenir des px depuis calc()/env()), relue après un redimensionnement. 0 avec l'ancien menu ou au bureau.
  const telBarre=matchMedia('(max-width:860px)');let barreH=-1;
  const hauteurBarre=de=>{
   if(!de.classList.contains('mt-barre')||!telBarre.matches)return 0;
   if(barreH<0&&document.body){const s=document.createElement('div');s.setAttribute('aria-hidden','true');s.style.cssText='position:absolute;left:0;top:0;width:0;height:var(--mt-barre-tot,0px);visibility:hidden;pointer-events:none';document.body.appendChild(s);barreH=s.offsetHeight||0;s.remove();}
   return Math.max(0,barreH);
  };
  const socle=()=>{
   rafSocle=0;if(disposed)return;
   const de=document.documentElement;
   if(!tel.matches||!bar){de.removeAttribute('data-hero-socle');return;}   // bureau : aucune lecture de géométrie
   const H=innerHeight,b=bar.getBoundingClientRect(),bh=hauteurBarre(de);   // zone des pastilles : 48 px + 12 px de marge + 4 px (+ la barre)
   de.toggleAttribute('data-hero-socle',b.bottom>H-64-bh&&b.top<H-bh);
  };
  const planSocle=()=>{if(!rafSocle)rafSocle=requestAnimationFrame(socle);};
  on(window,'scroll',planSocle,{passive:true});on(window,'resize',()=>{barreH=-1;planSocle();});
  if(tel.addEventListener)on(tel,'change',planSocle);
  if(telBarre.addEventListener)on(telBarre,'change',()=>{barreH=-1;planSocle();});
  socle();
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(replacer);
  // état initial : « mots » est déjà affiché (premier écran, LCP), aucun changement visuel ici
  slides.forEach((s,i)=>{if(i){s.inert=true;s.setAttribute('aria-hidden','true');s.removeAttribute('data-hero-actif');}});
  const s0=slides[0];s0.setAttribute('data-hero-actif','');s0.toggleAttribute('data-hero-reduit',reduit());
  root.dataset.ton=s0.dataset.ton||'lin';root.dataset.heroI='0';root.dataset.active='0';
  tabs.forEach(t=>{const a=t===tabOf[0];t.setAttribute('aria-selected',String(a));t.tabIndex=a?0:-1;});
  root.dataset.heroPret='true';root.dataset.ready='true';
  placer();jauge(0,true);planPre();etat();
  // l'entrée du premier héros part après les scripts différés des héros (ils écoutent déjà)
  const entree0=()=>{if(!disposed&&index===0)emit(s0,'mt-hero:entree',{reduit:reduit()});};
  // (un script defer s'exécute en readyState 'interactive', AVANT le DOMContentLoaded : on attend ce dernier,
  //  sauf s'il est déjà passé — rechargement de section dans l'éditeur, script injecté tard)
  const dclPasse=()=>{if(document.readyState==='complete')return true;const n=performance.getEntriesByType&&performance.getEntriesByType('navigation')[0];return !!(n&&n.domContentLoadedEventEnd>0);};
  if(dclPasse())setTimeout(entree0,0);else on(document,'DOMContentLoaded',()=>setTimeout(entree0,0),{once:true});
  // petite API (tests, éditeur) : root.mtHero.aller('lieu' | 2), .pause(), .reprendre()
  root.mtHero={aller:(x,o)=>{const i=typeof x==='number'?x:slides.findIndex(s=>s.dataset.heroId===x);if(i>=0)manuel(i,o);},pause:()=>{if(!arret)pause.click();},reprendre:()=>{if(arret)pause.click();},etat:()=>({index,id:slides[index].dataset.heroId,arret,gel,survol,focusClavier,visible,tourne:tourne()})};
  instances.set(root,()=>{disposed=true;clearTimeout(timerPre);cancelAnimationFrame(rafSocle);document.documentElement.removeAttribute('data-hero-socle');abort.abort();io&&io.disconnect();ro&&ro.disconnect();instances.delete(root);delete root.dataset.ready;delete root.dataset.heroPret;delete root.mtHero;});
 }
 const within=(scope,fn)=>{if(scope.matches&&scope.matches('[data-home-reel]'))fn(scope);scope.querySelectorAll&&scope.querySelectorAll('[data-home-reel]').forEach(fn);};
 within(document,init);
 document.addEventListener('shopify:section:load',e=>within(e.target,init));
 document.addEventListener('shopify:section:unload',e=>within(e.target,r=>instances.get(r)&&instances.get(r)()));
})();
